// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import PhotoSheetProduct from "./photo-sheet-product.js"
import PhotoType from "./photo-type.js"
import SheetLayoutBox from "./sheet-layout-box.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_sheet_product_id": {
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_sheet_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_type_id": {
      "column": {
        "default": null,
        "name": "photo_type_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "sheet_layout_box_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_box_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_box_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PhotoSheetProductBox",
  "collectionKey": "photo_sheet_product_boxes",
  "collectionName": "photo_sheet_product_boxes",
  "i18nKey": "photo_sheet_product_box",
  "camelizedLower": "photoSheetProductBox",
  "name": "PhotoSheetProductBox",
  "nameDasherized": "photo-sheet-product-box",
  "pluralName": "photo_sheet_product_boxes",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_type",
      "macro": "belongs_to",
      "resource_name": "PhotoType",
      "through": null
    },
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "sheet_layout_box",
      "macro": "belongs_to",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_sheet_product_id",
      "column": {
        "default": null,
        "name": "photo_sheet_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_type_id",
      "column": {
        "default": null,
        "name": "photo_type_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "sheet_layout_box_id",
      "column": {
        "default": null,
        "name": "sheet_layout_box_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "PhotoType",
      "collectionName": "photo_types",
      "foreignKey": "photo_type_id",
      "name": "photo_type",
      "macro": "belongs_to",
      "resource_name": "PhotoType",
      "through": null
    },
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_box_id",
      "name": "sheet_layout_box",
      "macro": "belongs_to",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product_box",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProductBox. */
export default class PhotoSheetProductBox extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSheetProductId() {
    return this.readAttributeUnderscore("photo_sheet_product_id")
  }

  /** @returns {boolean} */
  hasPhotoSheetProductId() {
    const value = this.photoSheetProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoTypeId() {
    return this.readAttributeUnderscore("photo_type_id")
  }

  /** @returns {boolean} */
  hasPhotoTypeId() {
    const value = this.photoTypeId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutBoxId() {
    return this.readAttributeUnderscore("sheet_layout_box_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutBoxId() {
    const value = this.sheetLayoutBoxId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./photo-sheet-product.js").default | null} */
  photoSheetProduct() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProduct, reflectionName: "photo_sheet_product"})
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  loadPhotoSheetProduct() {
    if (!("photoSheetProductId" in this)) throw new Error("Foreign key method wasn't defined: photoSheetProductId")

    const id = this.photoSheetProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product",
        model: this,
        modelClass: PhotoSheetProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product.js").default | null>} */
  ensurePhotoSheetProductLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product")
  }

  /** @returns {import("./photo-type.js").default | null} */
  photoType() {
    return this._readBelongsToReflection({modelClass: PhotoType, reflectionName: "photo_type"})
  }

  /** @returns {Promise<import("./photo-type.js").default | null>} */
  loadPhotoType() {
    if (!("photoTypeId" in this)) throw new Error("Foreign key method wasn't defined: photoTypeId")

    const id = this.photoTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_type",
        model: this,
        modelClass: PhotoType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-type.js").default | null>} */
  ensurePhotoTypeLoaded() {
    return this.ensureAssociationLoaded("photo_type")
  }

  /** @returns {import("./sheet-layout-box.js").default | null} */
  sheetLayoutBox() {
    return this._readBelongsToReflection({modelClass: SheetLayoutBox, reflectionName: "sheet_layout_box"})
  }

  /** @returns {Promise<import("./sheet-layout-box.js").default | null>} */
  loadSheetLayoutBox() {
    if (!("sheetLayoutBoxId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutBoxId")

    const id = this.sheetLayoutBoxId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout_box",
        model: this,
        modelClass: SheetLayoutBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout-box.js").default | null>} */
  ensureSheetLayoutBoxLoaded() {
    return this.ensureAssociationLoaded("sheet_layout_box")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
